/*
 * Sign Trade Supplies - sign post wind load calculator page (sections/sts-wind-load.liquid).
 *
 * The sums come from wind-load-engine.js (the same engine as the Sales Hub calculator, built by
 * build-engine.js) - this file only runs the page: inputs, the post options that pass, a scale
 * drawing of the chosen layout, and a parts list that goes into the basket. Prices and variants
 * are read live from /products/<handle>.js, so they follow the store.
 *
 * Parts rules (same as the Sales Hub / Itoris "Sign Blank with Channel" calculator):
 *   channels: ROUNDUP(height / 450) rows, min 2, one fewer above 5; length = width - 50 mm;
 *             Medium if the sign is over 0.55 m² or 1500 mm wide, otherwise Small.
 *   posts:    height to the top of the sign + planting depth (600 mm for signs under 2 m tall,
 *             800 mm otherwise - IHE Sign Structures Guide 2021, CD 354 / worked examples),
 *             rounded up to the next stock length.
 *   clips:    one per channel per post (bolts, nuts and washers are included with the clips).
 *   caps, baseplates: one per post.
 * The basket is always reached through /cart - Discountly applies Trade+ and quantity pricing there.
 */
(function () {
  'use strict';

  var root = document.getElementById('sts-wind-load');
  if (!root || typeof calculateWindLoad !== 'function') return;
  var cfg = JSON.parse(document.getElementById('sts-wl-config').textContent);

  // Products the parts list uses (handles from signtradesupplies.co.uk/products/...). Update here
  // if a product's URL changes. "cap" is the cap variant's size option for that post.
  var PRODUCTS = {
    posts: {
      'STS-RT500': { post: '50mm-diameter-round-sign-post', clip: '50mm-2-sign-post-clips', cap: '50mm Round' },
      'STS-RT760': { post: '76mm-diameter-aluminium-sign-post', clip: '76mm-sign-post-clips-3', cap: '76mm Round' },
      'STS-RT890': { post: '89mm-grey-powder-coated-sign-posts', clip: '89mm-3-5-sign-post-clips', cap: '89mm Round' },
      'STS-RT100': { post: '102mm-diameter-aluminium-sign-posts', clip: '102mm-4-sign-post-clip', cap: '102mm Round' },
      'STS-RT114': { post: '114mm-diameter-aluminium-sign-posts', clip: '114mm-4-1-2-sign-post-clip', cap: '114mm Round' },
      'STS-ST500': { post: '50-x50mm-aluminium-square-sign-posts', clip: '50mm-2-square-post-clips', cap: '50mm Square' },
      'STS-ST760': { post: 'copy-of-76mm-aluminium-box-section', clip: '76mm-3-square-post-clips', cap: '76mm Square' },
      'STS-ST100': { post: '100mm-x-100mm-mill-square-post', clip: '100mm-4-square-post-clips', cap: '100mm Square' }
    },
    cap: 'internal-push-fit-post-caps-round-square',
    baseplate: 'universal-sign-post-base-plate',
    channels: [
      { key: 'small-taped', size: 'Small', label: 'Small sign channel - with bonding tape', handle: 'small-sign-channel-with-bonding-tape' },
      { key: 'small', size: 'Small', label: 'Small sign channel - no tape', handle: 'small-sign-channel-grey-black-white-mill' },
      { key: 'medium-taped', size: 'Medium', label: 'Medium sign channel - with bonding tape', handle: 'medium-sign-channel-with-bonding-tape' },
      { key: 'medium', size: 'Medium', label: 'Medium sign channel - no tape', handle: 'medium-sign-channel-black-white-grey-mill' },
      { key: 'large', size: 'Large', label: 'Large sign channel', handle: 'large-sign-channel-grey' }
    ]
  };

  var $ = function (id) { return document.getElementById(id); };
  var els = {
    width: $('sts-wl-width'), height: $('sts-wl-height'), mount: $('sts-wl-mount'),
    region: $('sts-wl-region'), coastal: $('sts-wl-coastal'), cls: $('sts-wl-class'),
    custom: $('sts-wl-custom'), customField: $('sts-wl-custom-field'), exposed: $('sts-wl-exposed'),
    pressureNote: $('sts-wl-pressure-note'), error: $('sts-wl-error'), referral: $('sts-wl-referral'),
    referralReason: $('sts-wl-referral-reason'), referralLink: $('sts-wl-referral-link'),
    options: $('sts-wl-options'), optionsHint: $('sts-wl-options-hint'), layout: $('sts-wl-layout'),
    verdict: $('sts-wl-verdict'), drawing: $('sts-wl-drawing'), facts: $('sts-wl-facts'),
    parts: $('sts-wl-parts'), colour: $('sts-wl-colour'), lines: $('sts-wl-lines'),
    subtotal: $('sts-wl-subtotal'), add: $('sts-wl-add'), status: $('sts-wl-status')
  };

  function addOption(select, value, text) {
    var o = document.createElement('option');
    o.value = value; o.textContent = text;
    select.appendChild(o);
  }
  WIND_REGIONS.forEach(function (r) { addOption(els.region, r.key, r.label); });
  WIND_LOAD_CLASSES.forEach(function (c) {
    addOption(els.cls, c.key, c.key + ' - ' + c.pressure + ' N/m²' + (c.key === WIND_DEFAULT_CLASS ? ' (standard)' : ''));
  });
  addOption(els.cls, 'regional', 'Regional value for my sign (Table NA.2)');
  addOption(els.cls, 'other', 'Other - I have a figure');
  els.cls.value = WIND_DEFAULT_CLASS;

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(pence) { return '£' + (pence / 100).toFixed(2); }
  function pct(r) { return Math.round(r * 100) + '%'; }

  // ------------------------------------------------------------------ calculation

  function readInput() {
    var choice = els.cls.value;
    var pressure = '';
    if (choice === 'other') pressure = els.custom.value;
    else if (choice !== 'regional') {
      pressure = WIND_LOAD_CLASSES.filter(function (c) { return c.key === choice; })[0].pressure;
    }
    return {
      widthMm: els.width.value, heightMm: els.height.value, mountHeightMm: els.mount.value,
      regionKey: els.region.value, coastal: els.coastal.checked, exposedSite: els.exposed.checked,
      customPressure: pressure
    };
  }

  function pressureLabel(p) {
    var c = windClassFor(p);
    return p + ' N/m²' + (c ? ' (' + c + ')' : '');
  }

  function renderPressureNote(input, result) {
    els.customField.hidden = els.cls.value !== 'other';
    var region = WIND_REGIONS.filter(function (r) { return r.key === input.regionKey; })[0];
    var name = region ? region.label : 'your region';
    var regional = result.regionalPressure;
    els.pressureNote.className = 'sts-wl__note';
    if (els.cls.value === 'other' && !(Number(input.customPressure) > 0)) {
      els.pressureNote.textContent = 'Enter your wind pressure - until then the regional value is used.';
    } else if (regional === undefined) {
      els.pressureNote.textContent = '';
    } else if (regional === null) {
      els.pressureNote.textContent = 'This sign is too tall for the standard regional wind values.';
    } else if (result.windPressure !== undefined && result.windPressure < regional) {
      els.pressureNote.className = 'sts-wl__note sts-wl__note--warn';
      els.pressureNote.textContent = 'For a sign this size in ' + name + ', BS EN 12899-1 recommends ' + pressureLabel(regional) +
        (els.cls.value === 'other' ? ' - fine if your figure comes from a site-specific BS EN 1991-1-4 calculation.'
          : '. Choose that value (or "Regional value") to be on the safe side.');
    } else {
      els.pressureNote.textContent = 'BS EN 12899-1 regional value for this sign in ' + name + ': ' + pressureLabel(regional) + '.';
    }
  }

  var state = { input: null, result: null, options: [], selectedKey: null };
  // Once the customer picks an option, re-sorting (prices loading, colour change) won't move it.
  var userPicked = false;

  function optionKey(o) { return o.section.code + '|' + o.posts; }

  // Cost of an option's posts: posts x the price of the suggested stock length in the colour the
  // parts list will pick (the chosen colour if the post comes in it, else its first colour - so the
  // order matches what goes in the basket). Null until that post's product has loaded.
  function postCost(o) {
    var links = PRODUCTS.posts[o.section.code];
    var p = links && productData[links.post];
    var stock = stockLength(o.section.code, signParts(o).postLength);
    if (!p || !stock || stock.short) return null;
    var li = -1, ci = -1;
    p.options.forEach(function (_, i) {
      if (li === -1 && optionValues(p, i).some(function (v) { return parseLength(v) !== null; })) li = i;
    });
    p.options.forEach(function (_, i) { if (ci === -1 && i !== li) ci = i; });
    var pick = p.variants.filter(function (v) { return parseLength(v.options[li]) === stock.length; });
    if (ci !== -1) {
      var colours = optionValues(p, ci);
      var colour = colours.filter(function (v) { return colourMatch(v, els.colour.value); })[0] || colours[0];
      var inColour = pick.filter(function (v) { return v.options[ci] === colour; });
      if (inColour.length) pick = inColour;
    }
    var prices = pick.map(function (v) { return v.price; });
    return prices.length ? Math.min.apply(null, prices) * o.posts : null;
  }

  // Cheapest posts first (same idea as the Sales Hub). Options with more posts than the sign's
  // width sensibly takes (engine: one per 600 mm) go to the end; before prices load, the order is
  // by total aluminium.
  function sortOptions(options) {
    var max = state.result && state.result.sign ? windMaxSuggestedPosts(state.result.sign.widthMm) : Infinity;
    return options.slice().sort(function (a, b) {
      var overA = a.posts > max, overB = b.posts > max;
      if (overA !== overB) return overA ? 1 : -1;
      var ca = postCost(a), cb = postCost(b);
      if (ca !== null && cb !== null && ca !== cb) return ca - cb;
      return a.posts * a.section.area - b.posts * b.section.area || a.posts - b.posts;
    });
  }

  function strengthWords(u) {
    if (u <= 0.6) return 'Plenty of spare strength';
    if (u <= 0.85) return 'Comfortably strong enough';
    return 'Strong enough, but close to its limit';
  }
  var GOVERNS = {
    bending: 'the wind trying to bend the posts at ground level',
    shear: 'the sideways push on the posts at ground level',
    'point load': 'someone leaning on or knocking the sign',
    deflection: 'how far the sign sways in the wind',
    twist: 'the wind twisting a single post'
  };

  function recalc() {
    var input = readInput();
    var result = calculateWindLoad(input);
    state.input = input; state.result = result;
    renderPressureNote(input, result);

    els.error.hidden = !result.error;
    els.error.textContent = result.error || '';
    els.referral.hidden = !result.referral;
    if (result.referral) {
      els.referralReason.textContent = result.referral;
      els.referralLink.href = referralHref(input, result);
    }

    state.options = sortOptions(result.options || []);
    var keys = state.options.map(optionKey);
    if (keys.indexOf(state.selectedKey) === -1) userPicked = false;
    if (!userPicked) state.selectedKey = keys[0] || null;
    renderOptions();
    renderSelection();
  }

  // The first few (best-value) options are enough for most people; the rest sit behind "Show more".
  var OPTIONS_SHOWN = 4;
  var showAllOptions = false;

  // "Buy 2 x 3000 mm posts" for an option card - once that post's stock lengths have loaded.
  function buyLine(o) {
    var need = signParts(o).postLength;
    var stock = stockLength(o.section.code, need);
    if (!stock) return 'Each post needs ' + need + ' mm';
    if (stock.short) return 'Each post needs ' + need + ' mm - longer than our stock lengths';
    return 'Buy ' + o.posts + ' &times; ' + stock.length + ' mm post' + (o.posts === 1 ? '' : 's');
  }

  function renderOptions() {
    els.optionsHint.hidden = state.options.length === 0;
    var selectedIndex = state.options.map(optionKey).indexOf(state.selectedKey);
    var limit = showAllOptions ? state.options.length : Math.max(OPTIONS_SHOWN, selectedIndex + 1);
    var hidden = state.options.length - limit;
    els.options.innerHTML = state.options.slice(0, limit).map(function (o, i) {
      var key = optionKey(o);
      var on = key === state.selectedKey;
      var noun = o.posts === 1 ? 'post' : 'posts';
      return '<button type="button" role="radio" aria-checked="' + on + '" class="sts-wl__opt' + (on ? ' is-on' : '') +
        '" data-key="' + esc(key) + '">' +
        '<span class="sts-wl__opt-name">' + o.posts + ' &times; ' + esc(o.section.label) + ' ' + noun + '</span>' +
        (i === 0 ? '<span class="sts-wl__badge">Best value</span>' : '') +
        '<span class="sts-wl__opt-sub">' + strengthWords(o.utilisation) + ' &middot; ' + pct(o.utilisation) + ' of capacity</span>' +
        '<span class="sts-wl__opt-len">' + buyLine(o) + '</span>' +
        '<span class="sts-wl__bar"><span style="width:' + Math.min(100, Math.round(o.utilisation * 100)) + '%"></span></span>' +
        '</button>';
    }).join('') +
      (hidden > 0 ? '<button type="button" class="sts-wl__more" data-more>Show ' + hidden + ' more option' + (hidden === 1 ? '' : 's') + '</button>' : '');
  }

  function selectedOption() {
    for (var i = 0; i < state.options.length; i++) {
      if (optionKey(state.options[i]) === state.selectedKey) return state.options[i];
    }
    return null;
  }

  // ------------------------------------------------------------------ parts rules

  function channelCount(heightMm) {
    var sections = Math.ceil(heightMm / 450);
    if (sections < 2) return sections + 1;
    if (sections > 5) return sections - 1;
    return sections;
  }
  function suggestedChannelSize(widthMm, heightMm) {
    return (widthMm / 1000) * (heightMm / 1000) > 0.55 || widthMm > 1499 ? 'Medium' : 'Small';
  }
  function plantingDepth(topHeightMm) { return topHeightMm < 2000 ? 600 : 800; }

  // Shortest stock length of this post (in the chosen colour if it comes in it) that covers the
  // length needed - or the longest, flagged short. Null until the post's product has loaded.
  function stockLength(code, needed) {
    var links = PRODUCTS.posts[code];
    var p = links && productData[links.post];
    if (!p) return null;
    var li = -1;
    p.options.forEach(function (_, i) {
      if (li === -1 && optionValues(p, i).some(function (v) { return parseLength(v) !== null; })) li = i;
    });
    if (li === -1) return null;
    var inColour = p.variants.filter(function (v) {
      return v.options.some(function (x, i) { return i !== li && colourMatch(x, els.colour.value); });
    });
    var lengths = (inColour.length ? inColour : p.variants)
      .map(function (v) { return parseLength(v.options[li]); })
      .filter(function (L) { return L !== null; })
      .sort(function (a, b) { return a - b; });
    if (!lengths.length) return null;
    // Same rule as the engine: a stock length up to 50 mm short is fine - set the post shallower.
    var fit = lengths.filter(function (L) { return L >= needed - WIND_POST_LENGTH_TOLERANCE_MM; })[0];
    if (!fit) return { length: lengths[lengths.length - 1], short: true, under: 0 };
    return { length: fit, short: false, under: Math.max(0, needed - fit) };
  }

  function signParts(option) {
    var s = state.result.sign;
    var depth = plantingDepth(s.topHeightMm);
    return {
      channels: channelCount(s.heightMm),
      channelLength: Math.max(s.widthMm - 50, 100),
      channelSize: suggestedChannelSize(s.widthMm, s.heightMm),
      depth: depth,
      postLength: s.topHeightMm + depth,
      posts: option.posts
    };
  }

  // ------------------------------------------------------------------ drawing

  function renderDrawing(option, parts) {
    var s = state.result.sign;
    var W = 640, H = 430, padL = 90, padR = 120, padT = 34, padB = 54;
    var totalH = s.topHeightMm + parts.depth;
    var scale = Math.min((W - padL - padR) / s.widthMm, (H - padT - padB) / totalH);
    var signW = s.widthMm * scale, signH = s.heightMm * scale;
    var x0 = padL + (W - padL - padR - signW) / 2;
    var groundY = padT + s.topHeightMm * scale;
    var signTop = padT, signBottom = signTop + signH;
    var footY = groundY + parts.depth * scale;
    var postW = Math.max(option.section.size * scale, 3);
    var footW = Math.max(Math.max(300, option.section.size * 4) * scale, postW + 6);
    var fs = 12;
    var out = [];
    function line(x1, y1, x2, y2, cls) { out.push('<line x1="' + x1 + '" y1="' + y1 + '" x2="' + x2 + '" y2="' + y2 + '" class="' + (cls || '') + '"/>'); }
    function text(x, y, t, anchor) { out.push('<text x="' + x + '" y="' + y + '" text-anchor="' + (anchor || 'middle') + '" font-size="' + fs + '">' + esc(t) + '</text>'); }
    function hdim(xa, xb, y, t) { line(xa, y, xb, y, 'dim'); line(xa, y - 4, xa, y + 4, 'dim'); line(xb, y - 4, xb, y + 4, 'dim'); text((xa + xb) / 2, y - 5, t); }
    function vdim(x, ya, yb, t, left) {
      line(x, ya, x, yb, 'dim'); line(x - 4, ya, x + 4, ya, 'dim'); line(x - 4, yb, x + 4, yb, 'dim');
      text(left ? x - 8 : x + 8, (ya + yb) / 2 + 4, t, left ? 'end' : 'start');
    }

    out.push('<rect x="0" y="' + groundY + '" width="' + W + '" height="' + (H - groundY) + '" class="soil"/>');
    var centres = [];
    for (var i = 0; i < option.posts; i++) {
      var cmm = s.widthMm * (2 * i + 1) / (2 * option.posts);
      var cx = x0 + cmm * scale;
      centres.push(cmm);
      out.push('<rect x="' + (cx - footW / 2) + '" y="' + groundY + '" width="' + footW + '" height="' + (footY - groundY) + '" class="footing"/>');
      // Posts run up behind the sign to its top edge - that's why post length = top of sign + planting.
      out.push('<rect x="' + (cx - postW / 2) + '" y="' + signTop + '" width="' + postW + '" height="' + (footY - signTop) + '" class="post"/>');
      out.push('<rect x="' + (cx - Math.max(150 * scale, postW + 4) / 2) + '" y="' + (footY - 3) + '" width="' + Math.max(150 * scale, postW + 4) + '" height="3" class="plate"/>');
    }
    line(0, groundY, W, groundY, 'ground');
    out.push('<rect x="' + x0 + '" y="' + signTop + '" width="' + signW + '" height="' + signH + '" rx="2" class="sign"/>');
    for (var c = 0; c < parts.channels; c++) {
      var cy = signTop + signH * (c + 0.5) / parts.channels;
      line(x0 + 25 * scale, cy, x0 + signW - 25 * scale, cy, 'channel');
    }
    // Only label the channels when the label fits inside the sign (they're also listed beside it).
    if (signW > 170 && signH > 36) text(x0 + signW / 2, signTop + signH / 2 + 4, parts.channels + ' channels behind sign');

    hdim(x0, x0 + signW, signTop - 12, String(s.widthMm));
    var dx = x0 + signW + 16;
    vdim(dx, signTop, signBottom, String(s.heightMm));
    if (s.mountHeightMm > 0) vdim(dx, signBottom, groundY, String(s.mountHeightMm));
    vdim(dx, groundY, footY, parts.depth + ' in ground');
    vdim(x0 - 14, signTop, footY, parts.postLength + ' post', true);
    var stops = [0].concat(centres, [s.widthMm]);
    for (var k = 0; k < stops.length - 1; k++) {
      hdim(x0 + stops[k] * scale, x0 + stops[k + 1] * scale, footY + 22, String(Math.round(stops[k + 1] - stops[k])));
    }
    els.drawing.innerHTML = '<svg viewBox="0 0 ' + W + ' ' + H + '" role="img" aria-label="Scale drawing of a ' +
      s.widthMm + ' by ' + s.heightMm + ' mm sign on ' + option.posts + ' ' + esc(option.section.label) + ' posts">' + out.join('') + '</svg>';
  }

  function renderSelection() {
    var o = selectedOption();
    els.layout.hidden = !o;
    els.parts.hidden = !o;
    if (!o) return;
    var parts = signParts(o);
    var noun = o.posts === 1 ? 'post' : 'posts';
    els.verdict.innerHTML = '<strong>' + o.posts + ' &times; ' + esc(o.section.label) + ' ' + noun + '</strong> &ndash; uses ' +
      pct(o.utilisation) + ' of ' + (o.posts === 1 ? 'its' : 'their') + ' capacity. The limiting factor is ' + GOVERNS[o.governing] + '.';
    renderFacts(o, parts);
    renderDrawing(o, parts);
    scheduleParts(o, parts);
  }

  function renderFacts(o, parts) {
    var s = state.result.sign;
    var stock = stockLength(o.section.code, parts.postLength);
    var spare = stock && !stock.short ? stock.length - parts.postLength : 0;
    var lengthNote = spare > 0 ? ' (' + spare + ' mm spare to trim)' :
      spare < 0 ? ' (set the post ' + (-spare) + ' mm shallower)' : '';
    var buy = !stock ? parts.postLength + ' mm' :
      stock.short ? 'Longer than our stock lengths - call us' : o.posts + ' × ' + stock.length + ' mm';
    var facts = [
      ['Post', o.section.label + ', ' + o.section.size + ' x ' + o.section.t + 'mm aluminium'],
      ['Post length to buy', buy],
      ['Post length needed', parts.postLength + ' mm = ' + s.topHeightMm + ' above ground + ' + parts.depth + ' in the ground' + lengthNote],
      ['Channels', parts.channels + ' rows, ' + parts.channelLength + ' mm long'],
      ['Sign area', state.result.areaSqm.toFixed(2) + ' m²'],
      ['Wind pressure', pressureLabel(state.result.windPressure)]
    ];
    els.facts.innerHTML = facts.map(function (f, i) {
      return '<dt>' + esc(f[0]) + '</dt><dd' + (i === 1 ? ' class="sts-wl__buy"' : '') + '>' + esc(f[1]) + '</dd>';
    }).join('');
  }

  // ------------------------------------------------------------------ parts list

  var productCache = {};
  var productData = {};
  function loadProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(handle); return r.json(); })
        .then(function (p) {
          // /products/<handle>.js gives options as {name, values} objects; only the names are needed.
          p.options = p.options.map(function (o) { return typeof o === 'string' ? o : o.name; });
          productData[handle] = p;
          return p;
        })
        .catch(function () { delete productCache[handle]; return null; });
    }
    return productCache[handle];
  }

  function parseLength(value) {
    if (/pack/i.test(value)) return null;
    var m = /(\d{3,5})\s*mm/i.exec(value);
    return m && !/round|square/i.test(value) ? Number(m[1]) : null;
  }
  function optionValues(product, i) {
    var seen = [];
    product.variants.forEach(function (v) { if (seen.indexOf(v.options[i]) === -1) seen.push(v.options[i]); });
    return seen;
  }
  function colourMatch(value, colour) {
    var v = value.toLowerCase();
    if (colour === 'silver') return v.indexOf('silver') !== -1 || v.indexOf('mill') !== -1 || v.indexOf('anodised') !== -1;
    return v.indexOf(colour) !== -1;
  }

  // A parts line: one product, which options we pick for it, and how many.
  function makeLine(spec, product) {
    var line = {
      id: spec.id, product: product, label: spec.label, minLength: spec.minLength || 0, tolerance: spec.tolerance || 0,
      sizeValue: spec.sizeValue || null, baseQty: spec.qty, perPiece: spec.perPiece || false,
      include: true, chosen: [], kinds: [], manualQty: null, note: '', choices: spec.choices || null
    };
    product.options.forEach(function (name, i) {
      var values = optionValues(product, i);
      var kind = 'other';
      if (line.sizeValue && values.some(function (v) { return v.toLowerCase() === line.sizeValue.toLowerCase(); })) kind = 'size';
      else if (values.some(function (v) { return parseLength(v) !== null; })) kind = 'length';
      else if (/colou?r|finish/i.test(name)) kind = 'colour';
      line.kinds[i] = kind;
    });
    pickOptions(line, els.colour.value);
    return line;
  }

  function variantsWhere(line, skipIndex) {
    return line.product.variants.filter(function (v) {
      return v.options.every(function (val, i) {
        return i === skipIndex || line.chosen[i] === undefined || line.chosen[i] === val || line.kinds[i] === 'length';
      });
    });
  }

  function pickOptions(line, colour) {
    var p = line.product;
    line.chosen = [];
    p.options.forEach(function (_, i) {
      var values = optionValues(p, i);
      if (line.kinds[i] === 'size') {
        line.chosen[i] = values.filter(function (v) { return v.toLowerCase() === line.sizeValue.toLowerCase(); })[0];
      }
    });
    p.options.forEach(function (_, i) {
      if (line.kinds[i] === 'size' || line.kinds[i] === 'length') return;
      var values = optionValues(p, i).filter(function (v) {
        return p.variants.some(function (va) {
          return va.options[i] === v && va.options.every(function (x, j) { return line.kinds[j] !== 'size' || x === line.chosen[j]; });
        });
      });
      var match = line.kinds[i] === 'colour' ? values.filter(function (v) { return colourMatch(v, colour); })[0] : null;
      line.chosen[i] = match || values[0];
    });
    pickLength(line);
  }

  // Shortest stock length that covers what's needed; if none does, the longest (and channels
  // are then bought in more than one piece).
  function pickLength(line) {
    var p = line.product;
    var li = line.kinds.indexOf('length');
    line.pieces = 1;
    line.note = '';
    if (li === -1) return;
    var lengths = [];
    variantsWhere(line, li).forEach(function (v) {
      var L = parseLength(v.options[li]);
      if (L !== null && lengths.indexOf(L) === -1) lengths.push(L);
    });
    lengths.sort(function (a, b) { return a - b; });
    if (!lengths.length) return;
    var fit = lengths.filter(function (L) { return L >= line.minLength - line.tolerance; })[0];
    var chosenLen = fit || lengths[lengths.length - 1];
    if (!fit) {
      if (line.perPiece) {
        line.pieces = Math.ceil(line.minLength / chosenLen);
        line.note = 'Your sign is wider than our longest channel, so this is ' + line.pieces + ' pieces per row.';
      } else {
        line.note = 'Longer than our longest stock length (' + chosenLen + ' mm) - call us and we can help.';
      }
    }
    line.chosen[li] = optionValues(p, li).filter(function (v) { return parseLength(v) === chosenLen; })[0];
  }

  function lineVariant(line) {
    var p = line.product;
    return p.variants.filter(function (v) {
      return v.options.every(function (val, i) { return line.chosen[i] === val; });
    })[0] || null;
  }
  function lineQty(line) {
    return line.manualQty !== null ? line.manualQty : line.baseQty * line.pieces;
  }

  var lines = [];
  var partsTimer = null;
  var partsVersion = 0;
  function scheduleParts(option, parts) {
    clearTimeout(partsTimer);
    partsTimer = setTimeout(function () { buildParts(option, parts); }, 250);
  }

  function channelChoice() {
    var sel = document.querySelector('[data-wl-channel]');
    return sel ? sel.value : null;
  }

  function buildParts(option, parts) {
    var version = ++partsVersion;
    var links = PRODUCTS.posts[option.section.code];
    if (!links) { els.lines.innerHTML = ''; return; }
    var keepChannel = channelChoice();
    var channel = PRODUCTS.channels.filter(function (c) { return c.key === keepChannel; })[0] ||
      PRODUCTS.channels.filter(function (c) { return c.size === parts.channelSize; })[0] || PRODUCTS.channels[0];
    var specs = [
      { id: 'post', handle: links.post, label: 'Sign posts - each needs ' + parts.postLength + ' mm, incl. ' + parts.depth + ' mm in the ground', qty: parts.posts, minLength: parts.postLength, tolerance: WIND_POST_LENGTH_TOLERANCE_MM },
      { id: 'clip', handle: links.clip, label: 'Post clips (bolts, nuts & washers included)', qty: parts.posts * parts.channels },
      { id: 'cap', handle: PRODUCTS.cap, label: 'Post caps', qty: parts.posts, sizeValue: links.cap },
      { id: 'channel', handle: channel.handle, label: 'Sign channel', qty: parts.channels, minLength: parts.channelLength, perPiece: true, choices: channel.key },
      { id: 'baseplate', handle: PRODUCTS.baseplate, label: 'Baseplate for planted foundation', qty: parts.posts }
    ];
    els.lines.innerHTML = '<div class="sts-wl__loading">Loading parts&hellip;</div>';
    Promise.all(specs.map(function (s) { return loadProduct(s.handle); })).then(function (products) {
      if (version !== partsVersion) return;
      lines = [];
      specs.forEach(function (s, i) { if (products[i]) lines.push(makeLine(s, products[i])); });
      renderLines();
    });
  }

  function renderLines() {
    els.lines.innerHTML = lines.map(function (line, idx) {
      var p = line.product;
      var v = lineVariant(line);
      var qty = lineQty(line);
      var img = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
      var selects = '';
      if (line.id === 'channel') {
        selects += '<select data-wl-channel aria-label="Channel type">' + PRODUCTS.channels.map(function (c) {
          return '<option value="' + esc(c.key) + '"' + (c.key === line.choices ? ' selected' : '') + '>' + esc(c.label) + '</option>';
        }).join('') + '</select>';
      }
      p.options.forEach(function (name, i) {
        if (line.kinds[i] === 'size') return;
        var values = optionValues(p, i).filter(function (val) {
          if (line.kinds[i] === 'length' && parseLength(val) === null) return false;
          return p.variants.some(function (va) {
            return va.options[i] === val && va.options.every(function (x, j) { return j === i || line.kinds[j] === 'length' || x === line.chosen[j]; });
          });
        });
        if (values.length < 2) return;
        selects += '<select data-line="' + idx + '" data-opt="' + i + '" aria-label="' + esc(name) + '">' + values.map(function (val) {
          return '<option' + (val === line.chosen[i] ? ' selected' : '') + '>' + esc(val) + '</option>';
        }).join('') + '</select>';
      });
      var price = v ? v.price : 0;
      var stock = v && !v.available ? '<div class="sts-wl__meta sts-wl__warn">Currently out of stock - we will confirm lead time.</div>' : '';
      var missing = !v ? '<div class="sts-wl__meta sts-wl__warn">That combination isn\'t available - try another option.</div>' : '';
      return '<div class="sts-wl__trow' + (line.include ? '' : ' is-off') + '">' +
        '<div><input type="checkbox" aria-label="Include ' + esc(p.title) + '" data-inc="' + idx + '"' + (line.include ? ' checked' : '') + '></div>' +
        '<div class="sts-wl__prod">' + (img ? '<img src="' + esc(img) + '" alt="" width="52" height="52" loading="lazy">' : '') +
          '<div><span class="sts-wl__meta">' + esc(line.label) + '</span>' +
          '<a class="sts-wl__pname" href="/products/' + esc(p.handle) + '" target="_blank" rel="noopener">' + esc(p.title) + '</a>' +
          (selects ? '<div class="sts-wl__selects">' + selects + '</div>' : '') +
          (line.note ? '<div class="sts-wl__meta sts-wl__warn">' + esc(line.note) + '</div>' : '') + stock + missing + '</div></div>' +
        '<div class="sts-wl__price" data-label="Unit price">' + money(price) + '</div>' +
        '<div data-label="Qty"><input class="sts-wl__qty" type="number" min="0" step="1" value="' + qty + '" data-qty="' + idx + '" aria-label="Quantity"></div>' +
        '<div class="sts-wl__price" data-label="Total"><strong>' + money(price * qty) + '</strong></div>' +
        '</div>';
    }).join('');
    renderTotal();
  }

  function renderTotal() {
    var total = 0;
    lines.forEach(function (line) {
      var v = lineVariant(line);
      if (line.include && v) total += v.price * lineQty(line);
    });
    els.subtotal.textContent = money(total);
    els.add.disabled = !lines.some(function (l) { return l.include && lineVariant(l) && lineQty(l) > 0; });
  }

  els.lines.addEventListener('change', function (e) {
    var t = e.target;
    if (t.hasAttribute('data-wl-channel')) {
      var o = selectedOption();
      if (o) buildParts(o, signParts(o));
      return;
    }
    if (t.hasAttribute('data-inc')) {
      lines[Number(t.getAttribute('data-inc'))].include = t.checked;
    } else if (t.hasAttribute('data-qty')) {
      lines[Number(t.getAttribute('data-qty'))].manualQty = Math.max(0, Math.round(Number(t.value) || 0));
    } else if (t.hasAttribute('data-opt')) {
      var line = lines[Number(t.getAttribute('data-line'))];
      var i = Number(t.getAttribute('data-opt'));
      line.chosen[i] = t.value;
      if (line.kinds[i] === 'length') {
        var L = parseLength(t.value);
        line.pieces = line.perPiece && L < line.minLength ? Math.ceil(line.minLength / L) : 1;
        line.note = !line.perPiece && L < line.minLength - line.tolerance ? 'Shorter than the ' + line.minLength + ' mm this sign needs.' : '';
      } else {
        pickLength(line);
      }
    }
    renderLines();
  });

  // Stock lengths and prices can differ by colour, so the order, cards and facts follow the
  // colour choice too. Re-sorting picks the new cheapest unless the customer has chosen one.
  function refreshLengths() {
    if (!state.result) return;
    var before = state.selectedKey;
    state.options = sortOptions(state.options);
    if (!userPicked && state.options.length) state.selectedKey = optionKey(state.options[0]);
    renderOptions();
    var o = selectedOption();
    if (!o) return;
    if (state.selectedKey !== before) renderSelection();
    else renderFacts(o, signParts(o));
  }

  els.colour.addEventListener('change', function () {
    lines.forEach(function (line) { pickOptions(line, els.colour.value); });
    renderLines();
    refreshLengths();
  });

  els.add.addEventListener('click', function () {
    var items = lines.filter(function (l) { return l.include && lineVariant(l) && lineQty(l) > 0; })
      .map(function (l) { return { id: lineVariant(l).id, quantity: lineQty(l) }; });
    if (!items.length) return;
    els.add.disabled = true;
    els.status.textContent = 'Adding to your basket…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (body) { return { ok: r.ok, body: body }; });
    }).then(function (res) {
      if (!res.ok) throw new Error(res.body && (res.body.description || res.body.message) || 'Could not add to basket');
      // Always via the cart page - that's where Trade+ and quantity discounts are applied.
      window.location.href = '/cart';
    }).catch(function (err) {
      els.status.textContent = err.message + '. Please adjust the list and try again.';
      els.add.disabled = false;
    });
  });

  // ------------------------------------------------------------------ engineer's report

  function referralHref(input, result) {
    var region = WIND_REGIONS.filter(function (r) { return r.key === input.regionKey; })[0];
    var body = [
      'Hello, please could you help with a wind load assessment for this sign:',
      '',
      'Sign: ' + input.widthMm + ' mm wide x ' + input.heightMm + ' mm high',
      'Mount height (ground to bottom of sign): ' + input.mountHeightMm + ' mm',
      'Location: ' + (region ? region.label : '-') + (input.coastal ? ', within 5 km of the coast' : '') +
        (input.exposedSite ? ', exposed / funnelling / over 250 m' : ''),
      input.customPressure ? 'Basic wind pressure: ' + pressureLabel(Number(input.customPressure)) : '',
      'Calculator result: ' + result.referral,
      '',
      'Site address / postcode:',
      'Name and phone number:'
    ].join('\n');
    return 'mailto:' + (cfg.email || '') + '?subject=' + encodeURIComponent("Engineer's wind load report request") +
      '&body=' + encodeURIComponent(body);
  }

  // ------------------------------------------------------------------ wiring

  els.options.addEventListener('click', function (e) {
    if (e.target.closest('[data-more]')) {
      showAllOptions = true;
      renderOptions();
      return;
    }
    var btn = e.target.closest('[data-key]');
    if (!btn) return;
    state.selectedKey = btn.getAttribute('data-key');
    userPicked = true;
    renderOptions();
    renderSelection();
  });

  var recalcTimer = null;
  [els.width, els.height, els.mount, els.region, els.coastal, els.cls, els.custom, els.exposed].forEach(function (el) {
    var handler = function () { clearTimeout(recalcTimer); recalcTimer = setTimeout(recalc, 120); };
    el.addEventListener('input', handler);
    el.addEventListener('change', handler);
  });
  root.querySelector('form').addEventListener('submit', function (e) { e.preventDefault(); });

  recalc();
  // Load every post's stock lengths up front so each option card can say which length to buy.
  Promise.all(Object.keys(PRODUCTS.posts).map(function (code) { return loadProduct(PRODUCTS.posts[code].post); }))
    .then(refreshLengths);
})();
